export const VehicleMasterEndpoints = (builder) => ({

    getVehicleMasters: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/VehicleMaster/VehicleMaster',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['VehicleMaster'],
    }),

    getVehicleMasterById: builder.query({
        query: (id) => `/VehicleMaster/get-vehicle-master/${id}`,
        providesTags: (result, error, id) => [{ type: 'VehicleMaster', id }],
    }),

    saveVehicleMaster: builder.mutation({
        query: (data) => ({
            url: '/VehicleMaster/SaveVehicleMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['VehicleMaster'],
    }),

    updateVehicleMaster: builder.mutation({
        query: ({ id, data }) => ({
            url: `/VehicleMaster/SaveVehicleMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'VehicleMaster', id },
            'VehicleMaster'
        ],
    }),

    deleteVehicleMaster: builder.mutation({
        query: (id) => ({
            url: `/VehicleMaster/delete-vehicle-master/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['VehicleMaster'],
    }),

    bulkDeleteVehicleMaster: builder.mutation({
        query: (ids) => ({
            url: "/VehicleMaster/bulk-delete-vehicle-master",
            method: "POST",
            body: { ids },
        }),
        invalidatesTags: ['VehicleMaster'],
    }),

    // Cascading dropdown: Models filtered by MakeID (+ optional VehicleType)
    getVehicleModelsForDropdown: builder.query({
        query: ({ makeId, vehicleType } = {}) => {
            const params = new URLSearchParams();
            if (makeId) params.append('makeId', makeId);
            if (vehicleType) params.append('type', vehicleType);
            return `/VehicleMaster/get-models-for-dropdown?${params.toString()}`;
        },
        providesTags: ['VehicleModelMaster'],
    }),

    // Cascading dropdown: distinct Variant values for a ModelID
    getVehicleVariantsForDropdown: builder.query({
        query: (modelId) =>
            `/VehicleMaster/get-variants-for-dropdown?modelId=${modelId}`,
        providesTags: ['VehicleMaster'],
    }),

});

